import { render, staticRenderFns } from "./GLoading.vue?vue&type=template&id=13b05c86&scoped=true&"
import script from "./GLoading.vue?vue&type=script&lang=ts&"
export * from "./GLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b05c86",
  null
  
)

export default component.exports